import { InitPage } from "../index";

declare let App: any;

class AdminClientActivityReport {
  private refreshFill: any;
  private refreshPct: any;
  private savedExclusions = "";
  private savedState: { [clientId: string]: string } = {};
  private hoverIndex = 0;
  private toastTimer: any;
  private backdropMouseDownTarget: any = null;

  constructor() {
    const _self = this;
    $("document").ready(function () {
      _self.subscribeChannel();
      // Define
      _self.refreshFill = $("#refreshFill");
      _self.refreshPct = $("#refreshPct");
      // Init
      _self.refreshFill.css("width", "0");
      _self.refreshPct.text("0%");
      _self.bindModals();
      _self.bindExclusions();
      _self.showFlashToast();
    });
  }

  toast(message: string, kind: "success" | "error") {
    const $toast = $("#activityToast");
    window.clearTimeout(this.toastTimer);
    $toast.text(message).toggleClass("is-error", kind === "error").addClass("show");
    this.toastTimer = window.setTimeout(() => $toast.removeClass("show"), 2400);
  }

  showFlashToast() {
    const $toast = $("#activityToast");
    const alert = String($toast.attr("data-alert") || "");
    const notice = String($toast.attr("data-notice") || "");
    if (alert) this.toast(alert, "error");
    else if (notice) this.toast(notice, "success");
  }

  bindModals() {
    const ns = ".activityModals";
    const $doc = $(document);
    $doc.off(ns);

    const openers: { [button: string]: string } = {
      "#btnSettings": "thresholdModal",
      "#btnNotif": "notifModal",
      "#btnRefresh": "refreshModal",
      "#btnExport": "exportModal",
    };
    Object.keys(openers).forEach((button) => {
      $doc.on(`click${ns}`, button, () => this.openModal(openers[button]));
    });

    $doc.on(`mousedown${ns}`, ".modal-backdrop", (e: any) => {
      this.backdropMouseDownTarget = e.target;
    });
    $doc.on(`click${ns}`, ".modal-backdrop", (e: any) => {
      const startedOnBackdrop = this.backdropMouseDownTarget === e.currentTarget;
      this.backdropMouseDownTarget = null;
      if (e.target === e.currentTarget && startedOnBackdrop) $(e.currentTarget).removeClass("open");
    });
    $doc.on(`click${ns}`, ".modal-backdrop [data-close]", (e: any) => {
      $(e.currentTarget).closest(".modal-backdrop").removeClass("open");
    });
    $doc.on(`keydown${ns}`, (e: any) => {
      if (e.key !== "Escape") return;
      if ($(".row-menu.open").length > 0) this.closeRowMenus();
      else $(".modal-backdrop.open").removeClass("open");
    });
  }

  bindExclusions() {
    const ns = ".activityExclusions";
    const $doc = $(document);
    $doc.off(ns);
    this.captureSavedExclusions();

    $doc.on(`click${ns}`, "#btnExclusions, #exclusionsPill, [data-open-exclusions]", () => {
      this.resetExclusions();
      this.openModal("exclusionsModal");
    });

    $doc.on(`mousedown${ns}`, "#exSave", (e: any) => e.preventDefault());

    $doc.on(`click${ns}`, "[data-row-menu-toggle]", (e: any) => {
      const $menu = $(e.currentTarget).closest(".row-menu");
      const wasOpen = $menu.hasClass("open");
      this.closeRowMenus();
      if (!wasOpen) this.openRowMenu($menu);
    });
    $(window).off(ns).on(`resize${ns}`, () => this.positionRowMenu());
    window.removeEventListener("scroll", this.onScrollCapture, true);
    window.addEventListener("scroll", this.onScrollCapture, true);
    $doc.on(`click${ns}`, (e: any) => {
      if ($(e.target).closest(".row-menu").length === 0) this.closeRowMenus();
      if ($(e.target).closest(".ex-search").length === 0) this.toggleResults(false);
    });

    $doc.on(`click${ns}`, "[data-exclude-client]", (e: any) => this.openExcludeTenant($(e.currentTarget)));

    $doc.on(`input${ns}`, "#exSearch", (e: any) => {
      $(e.currentTarget).removeData("pickedId");
      this.hoverIndex = 0;
      this.filterSearch(String($(e.currentTarget).val()));
    });
    $doc.on(`focus${ns}`, "#exSearch", (e: any) => this.filterSearch(String($(e.currentTarget).val())));
    $doc.on(`keydown${ns}`, "#exSearch", (e: any) => this.searchKeydown(e));
    $doc.on(`click${ns}`, "#exSearchList .ex-opt", (e: any) => this.pickOption($(e.currentTarget)));
    $doc.on(`click${ns}`, "#exAddBtn", () => this.addPicked());
    $doc.on(`click${ns}`, ".ex-suggest-chip", (e: any) => this.addFromData($(e.currentTarget), "Print-only"));
    $doc.on(`click${ns}`, "#exSuggestAll", () => {
      $(".ex-suggest-chip:not([hidden])").each((_i: number, chip: any) => this.addFromData($(chip), "Print-only"));
    });
    $doc.on(`click${ns}`, "[data-ex-remove]", (e: any) => this.removeRow($(e.currentTarget).closest(".ex-row")));

    $doc.on(`click${ns}`, "[data-ex-note-toggle]", (e: any) => {
      const $row = $(e.currentTarget).closest(".ex-row");
      $row.addClass("editing");
      $row.find(".ex-row-note").trigger("focus");
    });
    $doc.on(`keydown${ns}`, ".ex-row-note", (e: any) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      this.finishNoteEdit($(e.currentTarget).closest(".ex-row"));
    });
    $doc.on(`blur${ns}`, ".ex-row-note", (e: any) => this.finishNoteEdit($(e.currentTarget).closest(".ex-row")));
    $doc.on(`change${ns}`, "#exList [data-field]", () => this.syncExclusions());

    this.syncExclusions();
  }

  onScrollCapture = () => this.positionRowMenu();

  openRowMenu($menu: any) {
    $menu.addClass("open");
    $menu.find("[data-row-menu-toggle]").attr("aria-expanded", "true");
    this.positionRowMenu();
  }

  closeRowMenus() {
    $(".row-menu.open").removeClass("open").find("[data-row-menu-toggle]").attr("aria-expanded", "false");
  }

  positionRowMenu() {
    const $menu = $(".row-menu.open").first();
    if ($menu.length === 0) return;
    const button = $menu.find("[data-row-menu-toggle]").get(0) as HTMLElement;
    const list = $menu.find(".row-menu-list").get(0) as HTMLElement;
    const rect = button.getBoundingClientRect();
    const scroller = $menu.closest(".table-scroll").get(0) as HTMLElement | undefined;
    if (scroller) {
      const bounds = scroller.getBoundingClientRect();
      if (rect.bottom < bounds.top || rect.top > bounds.bottom || rect.right < bounds.left || rect.left > bounds.right) {
        this.closeRowMenus();
        return;
      }
    }
    const margin = 8;
    const gap = 6;
    const width = list.offsetWidth;
    const height = list.offsetHeight;
    let top = rect.bottom + gap;
    if (top + height > window.innerHeight - margin) top = rect.top - gap - height;
    top = Math.max(margin, Math.min(top, window.innerHeight - margin - height));
    const left = Math.max(margin, Math.min(rect.right - width, window.innerWidth - margin - width));
    list.style.top = `${top}px`;
    list.style.left = `${left}px`;
  }

  captureSavedExclusions() {
    this.savedExclusions = $("#exList").html() || "";
    this.savedState = this.currentExclusionState();
  }

  currentExclusionState() {
    const state: { [clientId: string]: string } = {};
    $("#exList .ex-row").each((_i: number, row: any) => {
      const $row = $(row);
      state[String($row.data("clientId"))] = `${$row.find('[data-field="reason"]').val()}|${$row.find('[data-field="note"]').val()}`;
    });
    return state;
  }

  resetExclusions() {
    $("#exList").html(this.savedExclusions);
    $("#exSearch").val("").removeData("pickedId");
    $("#exReason").val("Print-only");
    this.hoverIndex = 0;
    this.toggleResults(false);
    this.syncExclusions();
  }

  openModal(id: string) {
    $(`#${id}`).addClass("open");
  }

  openExcludeTenant($button: any) {
    const clientId = String($button.data("excludeClient"));
    const status = String($button.data("clientStatus") || "");
    const printOnlyIds: number[] = $("#exclude_tenant_form").data("printOnlyIds") || [];
    $("#excludeClientId").val(clientId);
    $("#excludeTenantName").text(String($button.data("clientName")));
    $("#excludeTenantCode").text(String($button.data("clientCode")));
    $("#excludeTenantLocation").text(String($button.data("clientLocation")));
    $("#excludeTenantStatus").attr("class", `qx-status ${status}`).text(status.charAt(0).toUpperCase() + status.slice(1));
    $("#excludeReason").val(printOnlyIds.includes(Number(clientId)) ? "Print-only" : "Other");
    $("#excludeNote").val("");
    this.closeRowMenus();
    this.openModal("excludeTenantModal");
  }

  isExcludedInDraft(clientId: any) {
    return $("#exList").find(`.ex-row[data-client-id="${clientId}"]`).length > 0;
  }

  visibleOptions() {
    return $("#exSearchList .ex-opt:not([hidden])");
  }

  filterSearch(term: string) {
    const needle = term.trim().toLowerCase();
    this.refreshOptions(needle);
    this.toggleResults(true);
  }

  refreshOptions(needle: string) {
    $("#exSearchList .ex-opt").each((_i: number, option: any) => {
      const $option = $(option);
      const match = String($option.data("search")).includes(needle);
      $option.prop("hidden", !match || this.isExcludedInDraft($option.data("clientId")));
    });
    this.applyHover();
  }

  applyHover() {
    const $options = this.visibleOptions();
    if (this.hoverIndex >= $options.length) this.hoverIndex = 0;
    $("#exSearchList .ex-opt").removeClass("hover");
    $options.eq(this.hoverIndex).addClass("hover");
    $("#exNoResults").toggleClass("visible", $options.length === 0);
  }

  toggleResults(open: boolean) {
    $("#exSearchList").toggleClass("open", open);
    $("#exSearch").attr("aria-expanded", String(open));
  }

  searchKeydown(e: any) {
    const count = this.visibleOptions().length;
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      if (!$("#exSearchList").hasClass("open")) this.filterSearch(String($("#exSearch").val()));
      const step = e.key === "ArrowDown" ? 1 : -1;
      this.hoverIndex = Math.max(0, Math.min(this.hoverIndex + step, count - 1));
      this.applyHover();
      const hovered = this.visibleOptions().get(this.hoverIndex);
      if (hovered) hovered.scrollIntoView({ block: "nearest" });
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (!$("#exAddBtn").prop("disabled")) this.addPicked();
    }
  }

  pickOption($option: any) {
    $("#exSearch").val(String($option.data("clientName"))).data("pickedId", String($option.data("clientId")));
    this.toggleResults(false);
  }

  addPicked() {
    const $search = $("#exSearch");
    const pickedId = $search.data("pickedId");
    let $option = pickedId ? $(`#exSearchList .ex-opt[data-client-id="${pickedId}"]`) : $();
    if ($option.length === 0 && String($search.val()).trim() !== "") $option = this.visibleOptions().eq(this.hoverIndex);
    if ($option.length === 0) {
      this.toast(String($("#exclusions_form").data("pickFirstMessage")), "error");
      return;
    }
    this.addFromData($option, String($("#exReason").val()));
    $search.val("").removeData("pickedId");
    $("#exReason").val("Print-only");
    this.hoverIndex = 0;
    this.toggleResults(false);
  }

  addFromData($source: any, reason: string) {
    this.addRow(String($source.data("clientId")), String($source.data("clientName")), String($source.data("clientCode")), reason);
  }

  addRow(clientId: string, name: string, code: string, reason: string) {
    const $list = $("#exList");
    $list.find(`.ex-row[data-client-id="${clientId}"]`).remove();

    const template = document.getElementById("exRowTemplate") as HTMLTemplateElement;
    const $row = $(template.content.firstElementChild.cloneNode(true) as HTMLElement);
    $row.attr("data-client-id", clientId);
    $row.find('[data-field="reason"]').attr("name", `exclusions[${clientId}][reason]`).val(reason);
    $row.find(".ex-row-reason").text(reason);
    $row.find('[data-field="note"]').attr("name", `exclusions[${clientId}][note]`);
    $row.find(".ex-row-name").text(name);
    $row.find(".ex-row-code").text(code);
    $list.prepend($row);

    this.syncExclusions();
  }

  finishNoteEdit($row: any) {
    const note = String($row.find(".ex-row-note").val()).trim();
    $row.find(".ex-note-text").text(note ? ` · ${note}` : "");
    $row.find("[data-ex-note-toggle]").text(note ? "Edit note" : "Add note");
    $row.removeClass("editing");
    this.syncExclusions();
  }

  removeRow($row: any) {
    $row.remove();
    this.syncExclusions();
  }

  syncExclusions() {
    const state = this.currentExclusionState();
    const ids = Object.keys(state);
    const changes =
      ids.filter((id) => this.savedState[id] !== state[id]).length +
      Object.keys(this.savedState).filter((id) => !(id in state)).length;

    $("#exCount").text(ids.length);
    $("#exList").toggle(ids.length > 0);
    $("#exEmpty").toggle(ids.length === 0);
    $("#exChanges").text(changes === 0 ? "No unsaved changes" : `${changes} unsaved change${changes === 1 ? "" : "s"}`);

    $(".ex-suggest-chip").each((_i: number, chip: any) => {
      $(chip).prop("hidden", this.isExcludedInDraft($(chip).data("clientId")));
    });
    const remaining = $(".ex-suggest-chip:not([hidden])").length;
    $("#exSuggest").prop("hidden", remaining === 0);
    $("#exSuggestTitle").text(`${remaining} tenant${remaining === 1 ? "" : "s"} look print-only`);
    $("#exSuggestAllCount").text(remaining);
    $("#exSuggestAll").toggle(remaining > 1);

    this.refreshOptions(String($("#exSearch").val() || "").trim().toLowerCase());
  }

  subscribeChannel() {
    App.cable.subscriptions.create(
      {
        channel: "Admin::ActivityReportChannel",
        roomId: "admin_activity_report",
      },
      {
        connected() {},
        disconnected() {},
        received: (data: any) => this.refreshReceivingData(data),
      },
    );
  }

  refreshReceivingData(data: any) {
    this.showProgress(data.progress);
    if (data.success) {
      this.toast("Activity data is refreshing....", "success");
      setTimeout(() => window.location.reload(), 3000);
    }
  }

  showProgress(percentage: Int8Array) {
    $("#refreshProgress").addClass("visible");
    const progress = `${percentage}%`;
    this.refreshFill.css("width", progress);
    this.refreshPct.html(progress);
  }
}

export function LoadPage() {
  InitPage("activity_reports", () => new AdminClientActivityReport());
}
